import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8000/api',
  withCredentials: false,
});

// Attach auth token to every request
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('dayrit_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// ── Auth ──────────────────────────────────────────────────────────────────
export const authApi = {
  login:    (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  logout:   ()     => api.post('/auth/logout'),
  me:       ()     => api.get('/auth/me'),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  resetPassword:  (data) => api.post('/auth/reset-password', data),
  updateProfile:  (data) => api.patch('/auth/profile', data),
};

// ── Tasks ─────────────────────────────────────────────────────────────────
export const tasksApi = {
  list:     (params = {}) => api.get('/tasks', { params }),
  create:   (data)        => api.post('/tasks', data),
  update:   (id, data)    => api.put(`/tasks/${id}`, data),
  remove:   (id)          => api.delete(`/tasks/${id}`),
  complete: (id)          => api.patch(`/tasks/${id}/complete`),
  search:   (q)           => api.get('/tasks/search', { params: { q } }),
  reorder:  (items)       => api.post('/tasks/reorder', { items }),
};

// ── Subtasks ──────────────────────────────────────────────────────────────
export const subtasksApi = {
  list:    (taskId)           => api.get(`/tasks/${taskId}/subtasks`),
  create:  (taskId, data)     => api.post(`/tasks/${taskId}/subtasks`, data),
  update:  (taskId, id, data) => api.patch(`/tasks/${taskId}/subtasks/${id}`, data),
  remove:  (taskId, id)       => api.delete(`/tasks/${taskId}/subtasks/${id}`),
  reorder: (taskId, items)    => api.post(`/tasks/${taskId}/subtasks/reorder`, { items }),
  // Calls the dedicated toggle route — backend flips done and sets completed_at
  toggle:  (taskId, id)       => api.patch(`/tasks/${taskId}/subtasks/${id}/toggle`),
};

// ── Categories ────────────────────────────────────────────────────────────
export const categoriesApi = {
  list:   ()         => api.get('/categories'),
  create: (data)     => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  remove: (id)       => api.delete(`/categories/${id}`),
};

// ── Analytics ─────────────────────────────────────────────────────────────
export const analyticsApi = {
  summary:    () => api.get('/analytics/summary'),
  streak:     () => api.get('/analytics/streak'),
  weekly:     () => api.get('/analytics/weekly'),
  byCategory: () => api.get('/analytics/by-category'),
};

// ── Habits ────────────────────────────────────────────────────────────────
export const habitsApi = {
  list:    (days = 7) => api.get('/habits', { params: { days } }),
  create:  (data)     => api.post('/habits', data),
  update:  (id, data) => api.put(`/habits/${id}`, data),
  remove:  (id)       => api.delete(`/habits/${id}`),
  toggle:  (id, date) => api.post(`/habits/${id}/toggle`, { date }),
  stats:   (id)       => api.get(`/habits/${id}/stats`),
  reorder: (items)    => api.post('/habits/reorder', { items }),
};

// ── Preferences ───────────────────────────────────────────────────────────
export const prefsApi = {
  get:    ()     => api.get('/preferences'),
  update: (data) => api.patch('/preferences', data),
};

export default api;